import {Platform} from 'react-native';
import RNConfig from 'react-native-config';
import {resolveApiUrl} from './api-url';

const IS_WEB = Platform.OS === 'web';
const WEB_ORIGIN =
  IS_WEB && typeof window !== 'undefined' ? window.location.origin : '';

const ENV_CONFIG = (IS_WEB ? process.env : RNConfig) as {
  REACT_APP_ENV: 'dev' | 'test' | 'uat' | 'prod' | 'local';
  REACT_APP_API_BASE_URL: string;
  REACT_APP_API_INDUSWIN_URL?: string;
  REACT_APP_API_SPORTS_URL?: string;
  REACT_APP_API_QUICK_URL?: string;
  REACT_APP_API_H5GAMES_URL?: string;
  REACT_APP_API_RACECAR_URL?: string;
  REACT_APP_API_LOTTO_URL?: string;
  REACT_APP_API_FANTASY_CENTER_URL?: string;
  REACT_APP_IM_URL?: string;
  REACT_APP_BETBY_SCRIPT_URL?: string;
  REACT_APP_API_IM_URL?: string;
  REACT_APP_GR8_IFRAME_URL?: string;
  REACT_APP_GAME_PIC_CDN?: string;
  REACT_APP_PICK11_URL?: string;
  /** 逗号分隔；命中 hostname 时与原生/PWA 一样走「类 App」体验逻辑（非 inApp） */
  REACT_APP_APP_EQUIVALENT_HOSTS?: string;
  [k: string]: string | number | undefined;
};

class Config {
  private _IMURL: string;
  private _codePushKey: string;
  private _baseUrl: string;
  private _betbyScriptUrl: string;
  private _imApiUrl: string;
  private _gr8IframeUrl: string;
  private _gamePicCdn: string;
  private _appEquivalentHosts: string[];

  get baseUrl() {
    return this._baseUrl;
  }
  private _induswinUrl: string | undefined;
  get induswinUrl() {
    return this._induswinUrl;
  }
  private _sportsUrl: string;
  get sportsUrl() {
    return this._sportsUrl;
  }
  private _quick3dUrl: string;
  private _lqiUrl: string;
  private _loiUrl: string;
  get quickUrl() {
    return this._quick3dUrl;
  }
  get quick3dUrl() {
    return this._quick3dUrl;
  }
  get lqiUrl() {
    return this._lqiUrl;
  }
  get loiUrl() {
    return this._loiUrl;
  }
  private _racecarUrl: string;
  get racecarUrl() {
    return this._racecarUrl;
  }
  private _lottoUrl: string;
  get lottoUrl() {
    return this._lottoUrl;
  }
  private _fantasyCenterUrl: string;
  get fantasyCenterUrl() {
    return this._fantasyCenterUrl;
  }
  private _pick11Url: string;
  get pick11Url() {
    return this._pick11Url;
  }
  private _reactH5Url = 'https://h5-games.pages.dev';
  get reactH5Url() {
    return this._reactH5Url;
  }
  get codePushKey() {
    return this._codePushKey;
  }
  get IMURL() {
    return this._IMURL;
  }

  get betbyScriptUrl() {
    return this._betbyScriptUrl;
  }

  get imApiUrl() {
    return this._imApiUrl;
  }
  get gr8IframeUrl() {
    return this._gr8IframeUrl;
  }
  get gamePicCdn() {
    return this._gamePicCdn;
  }

  get appEquivalentHosts() {
    return this._appEquivalentHosts;
  }

  get environment() {
    return ENV_CONFIG.REACT_APP_ENV || 'development';
  }

  constructor() {
    const baseUrl = ENV_CONFIG.REACT_APP_API_BASE_URL;
    const quickUrl = ENV_CONFIG.REACT_APP_API_QUICK_URL || baseUrl;

    // 环境变量是接口域名的唯一来源，专用地址缺失时回退到主接口。
    this._baseUrl = resolveApiUrl(baseUrl, WEB_ORIGIN);
    this._induswinUrl = resolveApiUrl(
      ENV_CONFIG.REACT_APP_API_INDUSWIN_URL || baseUrl,
      WEB_ORIGIN,
    );
    this._sportsUrl = resolveApiUrl(
      ENV_CONFIG.REACT_APP_API_SPORTS_URL || baseUrl,
      WEB_ORIGIN,
    );
    this._imApiUrl = resolveApiUrl(
      ENV_CONFIG.REACT_APP_API_IM_URL || baseUrl,
      WEB_ORIGIN,
    );
    this._quick3dUrl = resolveApiUrl(quickUrl, WEB_ORIGIN);
    this._lqiUrl = resolveApiUrl(quickUrl, WEB_ORIGIN);
    this._loiUrl = resolveApiUrl(quickUrl, WEB_ORIGIN);
    this._racecarUrl = resolveApiUrl(
      ENV_CONFIG.REACT_APP_API_RACECAR_URL || baseUrl,
      WEB_ORIGIN,
    );

    // 其他配置保持不变
    this._reactH5Url = ENV_CONFIG.REACT_APP_API_H5GAMES_URL || this._reactH5Url;
    this._lottoUrl = resolveApiUrl(
      ENV_CONFIG.REACT_APP_API_LOTTO_URL || ENV_CONFIG.REACT_APP_API_BASE_URL,
      WEB_ORIGIN,
    );
    this._codePushKey =
      ENV_CONFIG.REACT_APP_ENV === 'prod'
        ? '8a-pXwXXpthmS-7g7K-m9Rd21j-Mq8tRCcZAx'
        : ENV_CONFIG.REACT_APP_ENV === 'uat'
        ? '4iCFNCMI_qmCaPQ0pcGECubDUxJEbCkfebu47'
        : ENV_CONFIG.REACT_APP_ENV === 'test'
        ? '7kSyJbvevw2LscS9NfPQueMIUOMcLzDB2xvJW'
        : '';
    this._IMURL = ENV_CONFIG.REACT_APP_IM_URL || '';
    this._betbyScriptUrl = ENV_CONFIG.REACT_APP_BETBY_SCRIPT_URL || '';
    this._gr8IframeUrl = ENV_CONFIG.REACT_APP_GR8_IFRAME_URL || '';
    this._gamePicCdn =
      ENV_CONFIG.REACT_APP_GAME_PIC_CDN || 'cdn.cloudstaticfile.com';
    this._fantasyCenterUrl = resolveApiUrl(
      ENV_CONFIG.REACT_APP_API_FANTASY_CENTER_URL || baseUrl,
      WEB_ORIGIN,
    );
    this._pick11Url = resolveApiUrl(
      ENV_CONFIG.REACT_APP_PICK11_URL || baseUrl,
      WEB_ORIGIN,
    );
    const hostsRaw = ENV_CONFIG.REACT_APP_APP_EQUIVALENT_HOSTS || '';
    this._appEquivalentHosts = hostsRaw
      .split(',')
      .map(s => String(s).trim().toLowerCase())
      .filter(Boolean);
  }
}

export const envConfig = new Config();
export default envConfig;
